require('./slider');
require('./favorites');
require('./offer-request-lead');
require('./history-report-request-lead');
require('./newsletter');
require('./cookies');


// WEBPACK FOOTER //
// ./resources/assets/js/modules/index.js